import React from 'react';
import { ErrorBoundary } from '../_lib/components/ErrorBoundary/ErrorBoundary';
import { StandardLayout } from './Standard/StandardLayout';
import { PersonalProfileLayout } from './PersonalProfile/PersonalProfileLayout';
import { StandardDynamicWidthLayout } from './StandardDynamicWidth/StandardDynamicWidthLayout';
import { SectionWithWidgets } from '../types/api/Sections';
import { GlobalDocumentIds } from '../types/GlobalDocumentIds';
import { useSonTranslation } from '../translation/useSonTranslation';
import { LayoutTypes } from '../types/api/Composition';
import { ContextSection } from '../_sections/Context/ContextSection';
import { ReturnToTopArrow } from '../_lib/components/ReturnToTopArrow/ReturnToTopArrow';
import { FullWidthContent } from './FullWidthContent/FullWidthContent';
import { ContentMultiColumnSection } from '../_sections/Content/ContentMultiColumn';

type LayoutSwitcherProps = {
  layout: LayoutTypes;
  contentSection: SectionWithWidgets;
  contextSection?: ContextSection;
  contentMultiColumn?: ContentMultiColumnSection;
};

/**
 * Renders one of three Layouts inside <main />
 */
export function MainLayoutSwitcher({
  layout,
  contentSection,
  contentMultiColumn,
  contextSection,
}: LayoutSwitcherProps) {
  const { t } = useSonTranslation('glossary');

  const getLayout = () => {
    switch (layout) {
      case 'PersonalProfile':
        return <PersonalProfileLayout contentSection={contentSection} />;
      case 'Standard':
        return (
          <StandardLayout
            contentSection={contentSection}
            contentMultiColumn={contentMultiColumn}
            contextSection={contextSection}
          />
        );
      case 'StandardDynamicWidth':
        return <StandardDynamicWidthLayout contentSection={contentSection} contextSection={contextSection} />;
      case 'FullWidthContent':
        return <FullWidthContent contentSection={contentSection} contextSection={contextSection} />;
      default:
        return null;
    }
  };

  return (
    <main aria-label={t('content')} id={GlobalDocumentIds.mainContent} className="content-main">
      <ErrorBoundary>{getLayout()}</ErrorBoundary>
      <ReturnToTopArrow />
    </main>
  );
}
